import { SortIconBaseValueConverter } from 'General/Resources/ValueConverters/SortIconBase';
export class SortIconValueConverter extends SortIconBaseValueConverter {

}